import React, { useEffect } from 'react';

export default function IndustryBriefRedirect() {
  useEffect(() => {
    window.location.replace('/industrybrief');
  }, []);

  return <>Loading...</>;
}
